import Indicadores from './Indicadores'
export default {
    getOptionsBySystem(){
        return Indicadores().get('app-option/all')
    },
    createOption(companyId, data){
        return Indicadores().post('app-option/create/'+companyId, data)
    },
    getOptionsByCompany(companyId){
        return Indicadores().get('app-option/company/'+companyId)
    },
    saveOptionCompany(data){
        return Indicadores().post('app-option/company/save',data)
    },
    deleteOptionCompany(id){
        return Indicadores().delete('app-option/company/'+id)
    },

    getAllOptionGroup(){
        return Indicadores().get('app-option/group/all')
    },

    getAllOptionsByCompany(companyId){
        return Indicadores().get('app-option/company/'+companyId+'/option');
    },

    getOptionByGroupAndSector(groupId, sectorId){
        return Indicadores().get('app-option/sector/'+sectorId+'/group/'+groupId);
    },



    getOptionRole(){
        return Indicadores().get('app-option/role/all');
    },
    saveOptionRole(data){
        return Indicadores().post('app-option/role/save', data);
    },
    deleteOptionRole(id){
        return Indicadores().delete('app-option/role/'+id);
    },


    getOptionSectorEnable(sectorId, optionId){
        return Indicadores().get('app-option/sector/'+sectorId+'/option/'+optionId);
    },
    saveOptionSector(data){
        return Indicadores().post('app-option/sector/save', data);
    },
    deleteOptionSector(id){
        return Indicadores().delete('app-option/sector/'+id);
    },
    syncOptionToChildren(sectorId, optionId, config){
        return Indicadores().post('app-option/sector/sync-children', {
            sectorId,
            optionId,
            config
        });
    }

}